export default "/forecast.9f2a4772-a9c953.png";